import { ShapeOptions } from "@/components/annotations/objects/annotation-type";

export interface ContentImageMetaData {
	pageId: string;
	metaData: ImageMetaData;
}

export interface ImageMetaData {
	x: number;
	y: number;
	rotate: number;
	width: number;
	height: number;
	scaleX: number;
	scaleY: number;
	annotations?: Annotation[];
}

export const ImageMetaDataDefault: ImageMetaData = {
	x: 0,
	y: 0,
	width: 0,
	height: 0,
	rotate: 0,
	scaleX: 0,
	scaleY: 0,
	annotations: []
};

export interface ImageData {
	loading: boolean;
	name: string;
	type: string;
	url: string;
}
export interface Annotation extends ShapeOptions {}
